import {animate, state, style, transition, trigger,} from '@angular/animations';
import {Component, HostListener, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MenuItem} from 'primeng/api';

@Component({
    selector: 'dmp-page-heading',
    templateUrl: './page-heading.component.html',
    styleUrls: ['./page-heading.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                height: '*',
                padding: '20px',
            })),
            state('closed', style({
                height: '0px',
                padding: '20px auto',
            })),
            transition('open => closed', [animate('0.3s')]),
            transition('closed => open', [animate('0.3s')]),
        ]),
    ],
    standalone: false
})
export class PageHeadingComponent implements OnInit, OnChanges {
  
    @Input() items: MenuItem[];
    @Input() description: string;

    breadcrumb_items: MenuItem[];

    hide = false;

    ngOnInit(): void {
        this.onResize();
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.onResize();
    }
    @HostListener('window:resize', ['$event'])
    onResize() {
        if (window.innerWidth < 780) {
            this.breadcrumb_items = this.items.slice(-1);
        } else {
            this.breadcrumb_items = this.items.slice(0);
        }
    }
}
